import { combineReducers } from '@reduxjs/toolkit';
import archiveSubjectReducer from './archive-subject';
import createSubjectReducer from './create-subject';
import getSubjectReducer from './get-subject';
import getSubjectListReducer from './get-subject-list';
import getSubjectOnBoardAnalysisReducer from './get-subject-on-board-analysis';
import transferSubjectReducer from './transfer-subject';
import unarchiveSubjectReducer from './unarchive-subject';
import updateNextScreeningDateReducer from './update-next-screening-date';
import updateSubjectReducer from './update-subject';
import createSubjectListIterativeReducer from './create-subject-list-iterative';

const subjectReducer = combineReducers({
  archiveSubject: archiveSubjectReducer,
  createSubject: createSubjectReducer,
  getSubject: getSubjectReducer,
  getSubjectList: getSubjectListReducer,
  getSubjectOnBoardAnalysis: getSubjectOnBoardAnalysisReducer,
  transferSubject: transferSubjectReducer,
  unarchiveSubject: unarchiveSubjectReducer,
  updateNextScreeningDate: updateNextScreeningDateReducer,
  updateSubject: updateSubjectReducer,
  createSubjectListIterative: createSubjectListIterativeReducer
});

export default subjectReducer;